import { ICard } from './props'
import { Wrapper } from './styled'

export const Card = ({ isNotification, className, variant = 'primary', children, id, ...props }:ICard) => {
  return (
    <Wrapper id={id} variant={variant} {...props} className={className} isNotification={isNotification}>
      {children}
    </Wrapper>
  )
}